/**
 * select_controller.js — searchable <select> via Choices.js (Stimulus).
 *
 * Bind to a CONTAINER that wraps the <select>:
 *
 *   <div data-controller="select" data-select-sort="false" ...>
 *     <select id="client_id" name="client_id">...</select>
 *   </div>
 *
 * Choices moves the <select> into its own .choices wrapper INSIDE this container,
 * so the controller's own element never moves and cannot loop (see
 * VendorWidgetController for the full rationale). connect() wraps the inner
 * <select> in Choices; disconnect() and a connect-scoped turbo:before-cache both
 * call Choices.destroy(), restoring the bare <select> so the cached Turbo snapshot
 * has no Choices markup to re-wrap over.
 *
 * Config knobs (all optional data-* on the CONTAINER; defaults preserve the
 * original client-picker behaviour so existing consumers need no attributes):
 *   data-select-placeholder        placeholder chip text (default "Select a client")
 *   data-select-search-placeholder search box text       (default "Search clients...")
 *   data-select-item-text          Choices itemSelectText (default Choices' own)
 *   data-select-sort="false"       disable alphabetical sort (default: Choices sorts)
 *   data-select-result-limit       cap visible search matches (default: unset)
 */
import VendorWidgetController from "./_vendor_widget.js";

export default class extends VendorWidgetController {
        retryCount() { return 5; }

        vendorReady() { return typeof Choices !== 'undefined'; }

        widgetElement() { return this.element.querySelector('select'); }

        buildWidget(select) {
            var ds = this.element.dataset;
            var config = {
                searchEnabled: true,
                placeholder: true,
                placeholderValue: ds.selectPlaceholder || 'Select a client',
                searchPlaceholderValue: ds.selectSearchPlaceholder || 'Search clients...',
            };
            // Optional knobs — omitted by default so existing consumers keep
            // Choices' own defaults (alphabetical sort, "Press to select" hint).
            if ('selectItemText' in ds) config.itemSelectText = ds.selectItemText;
            if (ds.selectSort === 'false') config.shouldSort = false;
            if (ds.selectResultLimit) {
                config.searchResultLimit = parseInt(ds.selectResultLimit, 10);
            }
            var instance = new Choices(select, config);
            // Park on the <select> under the key turbo-compat.js's reactive
            // option-update path reads (append_option setChoices).
            select.choicesInstance = instance;
            return instance;
        }

        destroyWidget(instance, select) {
            if (instance && typeof instance.destroy === 'function') {
                try { instance.destroy(); } catch (_e) {}
            }
            if (select) select.choicesInstance = null;
        }
}
